export default {
  getOwnerByEntity: (state) => state.ownerByEntity || {},
};